export default __webpack_public_path__ + "static/media/orange1.4fd88f7c.svg";